import { Component, OnInit } from '@angular/core';
import { LocationSwitcherService } from '../../services/location-switcher/location-switcher.service';
import { TrpcService } from '../../services/trpc/trpc.service';
import { environment } from '../../../environments/environment';

const projectInfo = require('../../../../../../project-info.json');
const projectInfoLocal = require('../../../../../../project-info.local.json');

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  // Version information
  version = projectInfo.version;
  buildTimestamp = projectInfoLocal.buildDateTime;
  buildMode = projectInfo.buildMode;
  environment = environment.activeFile;

  // Prerelease access
  hasPreReleaseAccess: boolean = false;

  constructor(
    private locationSwitcherService: LocationSwitcherService,
    private trpcService: TrpcService
  ) { }

  async ngOnInit(): Promise<void> {
    // The LocationSwitcherService will automatically initialize itself
    // and start managing location state

    // Fetch user info to check prerelease access
    try {
      const userInfo = await this.trpcService.trpc.authRouter.getCurrentUser.query();
      this.hasPreReleaseAccess = userInfo?.hasPreReleaseAccess || false;
    } catch (error) {
      console.error('Failed to get user info:', error);
      this.hasPreReleaseAccess = false;
    }
  }

}
